/**
 * Texterna som ticken och bakgrundsfunktionen skriver på ett möte (kolumnen fel).
 * Egen fil utan beroenden, så att mötesvyn (motesText.ts) kan avgöra vilka
 * knappar ett fel ska ha utan att dra in klienterna för Klang och tal-till-text.
 *
 * Varje text lovar bara det som går att göra: ett möte som saknar ljud kan inte
 * ta emot en ny fil – då hänvisar texten till ett nytt möte, och "Försök igen"
 * erbjuds inte (felAtgarder i motesText.ts).
 */

const NYTT_MOTE_INSPELNING = 'Har du en inspelning av mötet kan du skapa ett nytt möte och ladda upp den där.';
const NYTT_MOTE_LJUDFIL = 'Skapa ett nytt möte och ladda upp ljudfilen där.';

export const GE_UPP_TEXT = {
  klang: `Klang hörde inte av sig om mötet. ${NYTT_MOTE_INSPELNING}`,
  stt: 'Utskriften blev aldrig klar. Försök igen.',
  sammanfattning: 'Sammanfattningen misslyckades tre gånger. Försök igen senare.',
} as const;

export const BOT_FOR_SEN_TEXT = 'Mötet hann börja utan bot';
// Med punkt, som i rulingen; briefen skrev texten utan – en hel svensk mening får punkt.
export const STT_AV_TEXT = 'Utskrift av uppladdade filer är inte påslagen än.';
export const STT_FEL_TEXT = `Utskriften kunde inte göras. Försök igen – eller skapa ett nytt möte och ladda upp ljudfilen där.`;
export const STT_TOM_TEXT = `Utskriften blev tom – inget tal hittades i ljudet. Kontrollera filen. ${NYTT_MOTE_LJUDFIL}`;
export const KLANG_TOM_TEXT = `Klang skickade ingen utskrift för mötet. ${NYTT_MOTE_INSPELNING}`;
export const KLANG_RADERAD_TEXT = `Samtalet raderades i Klang innan utskriften hann hämtas. ${NYTT_MOTE_INSPELNING}`;
export const SAMMANFATTNING_TILLFALLIG_TEXT = 'Sammanfattningen misslyckades. Ett nytt försök görs om en stund.';
export const SAMMANFATTNING_FEL_TEXT = 'Sammanfattningen kunde inte göras.';
export const INSPELNING_FOR_STOR_TEXT = `Inspelningen är för stor för att skrivas ut (högst 100 MB). Har du ljudet som fil kan du skapa ett nytt möte och ladda upp den där.`;
export const INSPELNING_SAKNAS_TEXT = `Inspelningen hittades inte. ${NYTT_MOTE_LJUDFIL}`;
export const INSPELNING_GE_UPP_TEXT = `Inspelningen kunde inte sättas ihop. Försök igen – eller skapa ett nytt möte och ladda upp ljudfilen där.`;
export const STT_SKICKA_GE_UPP_TEXT = 'Ljudfilen kunde inte skickas till utskrift. Försök igen.';
export const LJUD_SAKNAS_TEXT = `Ljudet saknas, så mötet kan inte skrivas ut. ${NYTT_MOTE_LJUDFIL}`;
export const BAKGRUND_SAKNAS_TEXT = 'Sammanfattningen kunde inte startas (serverinställning saknas).';
export const LJUD_GALLRAT_TEXT = `Ljudet hann raderas innan det skrevs ut. ${NYTT_MOTE_LJUDFIL}`;

/**
 * Fel där "Försök igen" bara leder tillbaka till samma fel: ljudet finns inte
 * (eller ger inget att skriva ut) och mötet kan inte ta emot nytt.
 */
export const FEL_UTAN_NYTT_FORSOK: readonly string[] = [
  LJUD_SAKNAS_TEXT,
  LJUD_GALLRAT_TEXT,
  // Samma ljud ger samma tomma utskrift.
  STT_TOM_TEXT,
  INSPELNING_FOR_STOR_TEXT,
  INSPELNING_SAKNAS_TEXT,
];
